// SR-012: wizyta zwykle trwa jeden dzień. Przedział pokazujemy tylko, gdy data końca
// istnieje i jest innym dniem niż data rozpoczęcia (raporty kopiowane mogą mieć end == start).
export const isMultiDayVisit = (
  start?: Date | string | null,
  end?: Date | string | null
): boolean => {
  if (!start || !end) return !!end && !start;
  const a = new Date(start);
  const b = new Date(end);
  if (isNaN(a.getTime()) || isNaN(b.getTime())) return false;
  return a.toDateString() !== b.toDateString();
};
